import React from 'react';
import { useDocumentInteractStart, useInteractMedia } from 'Hooks/Document';

import { InteractModalProps } from './common/interfaces';
import {
  InteractModalDesktop,
  InteractModalMobile,
  InteractModalTablet,
} from './components/Breakpoints';

function InteractModal(props: InteractModalProps) {
  const [isExtraMobile, isMedium, isTablet] = useInteractMedia(['xs', 'md', 'lg']);
  const isDocumentInteractLoading = useDocumentInteractStart(props.documentId);

  if (isExtraMobile) {
    return (
      <InteractModalMobile
        {...props}
        isDocumentInteractLoading={isDocumentInteractLoading}
      />
    );
  }

  if (isMedium || isTablet) {
    return (
      <InteractModalTablet
        {...props}
        isDocumentInteractLoading={isDocumentInteractLoading}
      />
    );
  }

  return (
    <InteractModalDesktop
      {...props}
      isDocumentInteractLoading={isDocumentInteractLoading}
    />
  );
}

export default InteractModal;
